/**
 * MultiselectDropdown
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React, { useState, useRef } from 'react';
import { Icon, Text } from 'ui-component-library/base';
import { useOutsideClick } from 'ui-component-library/hooks';
/** Multiselect dropdown component. */
var MultiselectDropdown = function (_a) {
    var id = _a.id, legend = _a.legend, children = _a.children, buttonSrText = _a.buttonSrText, selectedBuckets = _a.selectedBuckets, _b = _a.hasSearchField, hasSearchField = _b === void 0 ? false : _b, searchPlaceholder = _a.searchPlaceholder, className = _a.className, dropdownClassName = _a.dropdownClassName;
    var dropdownRef = useRef();
    var searchFieldRef = useRef();
    var _c = useState(false), visibleOptions = _c[0], setVisibleOptions = _c[1];
    var _d = useState(''), searchQuery = _d[0], setSearchQuery = _d[1];
    useOutsideClick(dropdownRef, function () {
        setVisibleOptions(false);
    });
    var buttonBorder = visibleOptions
        ? 'border-2 border-greySemiLight border-b-0 rounded-br-none rounded-bl-none'
        : 'border-2 border-greySemiLight';
    var textColor = visibleOptions ? 'text-black' : 'text-greyDarker';
    var renderChildren = function (children) {
        var renderedChildren = React.Children.map(children, function (child, index) {
            if (!child)
                return null;
            var props = child && child.props ? __assign({}, child.props) : {};
            if (hasSearchField &&
                typeof props.children === 'string' &&
                !props.children.toLowerCase().includes(searchQuery.toLowerCase())) {
                props.className = 'hidden';
            }
            return React.cloneElement(child, props);
        });
        return renderedChildren;
    };
    return (React.createElement("fieldset", { ref: dropdownRef, className: className },
        React.createElement("legend", { className: "sr-only" }, legend),
        React.createElement("div", { className: "flex justify-between relative" },
            React.createElement("button", { onClick: function () { return setVisibleOptions(function (visible) { return !visible; }); }, "aria-expanded": visibleOptions, "aria-controls": id + "-dropdown", type: "button", "data-button-action": legend, className: "flex justify-between items-center py-2 px-4 w-full rounded border-solid " + buttonBorder },
                React.createElement("span", { className: "mr-16 text-p leading-5 " + textColor },
                    buttonSrText && React.createElement("span", { className: "sr-only" }, buttonSrText),
                    legend),
                React.createElement("span", { className: "absolute right-4" },
                    !!selectedBuckets && selectedBuckets > 0 && (React.createElement("span", { className: "inline-block relative z-10 text-white text-sm w-8 mr-2 multieselect-dropdown-counter" }, selectedBuckets)),
                    React.createElement(Icon, { icon: "chevron", color: "#00636A", size: 0.75, "aria-hidden": "true", direction: !visibleOptions ? 'up' : 'down' })))),
        React.createElement("div", { hidden: !visibleOptions, id: id + "-dropdown", className: clsx(dropdownClassName, 'absolute px-2 pt-2 pb-0 bg-white border-solid border-2 border-greySemiLight z-20 max-h-160 max-w-160 overflow-y-auto overflow-x-hidden') },
            hasSearchField && (React.createElement("div", { className: "relative w-full mb-4" },
                React.createElement("label", { className: "sr-only", htmlFor: "filter-search-" + id }, searchPlaceholder),
                React.createElement("input", { type: "text", id: "filter-search-" + id, ref: searchFieldRef, name: "filter-search-" + id, placeholder: searchPlaceholder, value: searchQuery, onChange: function (e) { return setSearchQuery(e.target.value); }, onKeyPress: function (e) {
                        return e.key === 'Enter' && setSearchQuery(e.target.value);
                    }, autoComplete: "off", className: clsx('font-alt', 'text-p', 'leading-4', 'h-10', 'w-full', 'px-3', 'py-1', 'border-2', 'border-greySemiLight focus:border-blue', 'rounded', 'transition-all', 'focus:outline-none', 'disabled:text-greyLight', 'disabled:cursor-not-allowed', 'placeholder-greyDarker', 'placeholder-opacity-100', 'pr-10') }),
                React.createElement("button", { className: 'absolute p-2 right-0 w-auto', type: "button", onClick: function () {
                        var _a;
                        setSearchQuery(searchQuery ? '' : searchQuery);
                        (_a = searchFieldRef === null || searchFieldRef === void 0 ? void 0 : searchFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    } },
                    React.createElement(Text, { as: "span", styleAs: "screenReader" }, searchQuery ? 'Rensa sökfält' : 'Sök'),
                    React.createElement(Icon, { icon: "search", size: 1.25, "aria-hidden": true, color: "black", className: clsx(searchQuery && 'hidden') }),
                    React.createElement(Icon, { icon: 'clear', size: 1.25, "aria-hidden": true, color: "#75726B", className: clsx(!searchQuery && 'hidden') })))),
            React.createElement("div", { className: "flex flex-col" },
                " ",
                renderChildren(children)))));
};
export default MultiselectDropdown;
